export default function initEventTracking() {
    if (document.body.classList.contains('has-edit-mode-menu') || !window.dataLayer) {
        return;
    }
    window.addEventListener('load', function (event) {
        const $elements = document.querySelectorAll('[data-tracking="true"]');
        [...$elements].forEach($element => {
            $element.addEventListener('click', event => {
                let name = '';
                let variables = '';
                try {
                    name = $element.getAttribute('data-tracking-event');
                    variables = JSON.parse($element.getAttribute('data-tracking-variable'));
                } catch (e) {
                    console.error(e);
                }
                dataLayer.push({
                    event: name,
                    ...variables,
                });
            });
        });
    });
}
